export function ceilPrice(price: number | undefined, priceUnit: number, count = 100000) {
  return price ? Number(Math.ceil(price / priceUnit)) * count : 0;
}
